import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import { Language } from "../types";
import Cookies from "js-cookie";

type ContextType = {
  language: Language;
  setLanguage: (language: Language) => void;
};

const Context = createContext<ContextType>({
  language: Language.English,
  setLanguage: () => {},
});

const isValidLanguage = (language: string): language is Language =>
  Object.values(Language).includes(language as Language);

export const ContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const browserLanguage: string = navigator.language.split("-")[0];
  const languageFromCookies: string | undefined = Cookies.get("language");
  const initialLanguage: string = languageFromCookies || browserLanguage;

  const [language, setLanguage] = useState<Language>(
    isValidLanguage(initialLanguage)
      ? (initialLanguage as Language)
      : Language.English
  );

  useEffect(() => {
    Cookies.set("language", language);
  }, [language]);

  return (
    <Context.Provider value={{ language, setLanguage }}>
      {children}
    </Context.Provider>
  );
};

export const useContextProvider = () => {
  const ctx = useContext(Context);
  if (!ctx)
    throw new Error("useContextProvider must be used inside ContextProvider");
  return ctx;
};
